import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useState } from "react";
import { Button } from "../../../Helper/Button";
import { ConfirmationModal } from "../../../Helper/Modal";

export const TenantItemModal = ({ children, isOpen, onClose, title, onDelete, onConfirm, entityName }) => {
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

    return (
        <>
            <ConfirmationModal
                isOpen={confirmationModalOpen}
                onClose={() => setConfirmationModalOpen(false)}
                onConfirm={onDelete}
                header={`Delete ${entityName}`}
                color="danger"
                size="md"
            >
                Are you sure you want to delete this {entityName}? This action cannot be undone.
            </ConfirmationModal>

            <Modal isOpen={isOpen} size="l" onClosed={onClose}>
                <ModalHeader><span>{title}</span></ModalHeader>

                <ModalBody>
                    {children}
                </ModalBody>

                <ModalFooter className={`d-flex ${onDelete ? "justify-content-between" : "justify-content-end"}`}>
                    {onDelete && (
                        <Button color="danger" outline onClick={() => setConfirmationModalOpen(true)}>Delete</Button>
                    )}

                    <div className="d-flex gap-2">
                        <Button color="secondary" onClick={onClose}>Cancel</Button>
                        <Button color="primary" onClick={onConfirm}>Save</Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>

    );
};
